<template>
  <v-container>
    <v-btn rounded dark color="primary" @click="edit(getModelDefault(),null,false)">
      <v-icon>mdi-plus</v-icon>
    </v-btn>
    <v-list two-line>
      <div v-for="(item,i) in value" :key="i">
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>{{item.label}}</v-list-item-title>
            <v-list-item-subtitle>{{item.dataType}}</v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-action>
            <v-layout>
              <v-btn icon color="warning" @click="edit(item,i,false)">
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
              <v-btn icon color="error" @click="remove(i)">
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </v-layout>
          </v-list-item-action>
        </v-list-item>
        <v-divider></v-divider>
      </div>
    </v-list>
    <dialog-d
      ref="dialogRef"
      title="Field"
      :deleteButton="false"
      @confirm="confirm(false,$refs.form.validate())"
    >
      <action-field-form v-if="itemSelected" ref="form" v-model="itemSelected" />
    </dialog-d>
  </v-container>
</template>

<script>
import actionFieldForm from './actionFieldForm'
import objectValueListMixing from "@/mixins/objectPageLists/objectValueListMixing.js";
export default {
  name: "action-fields-tab-list",
  props: ["value"],
  mixins: [objectValueListMixing],
  components:{actionFieldForm},

  watch: {
    indexSelected() {},
  },
  methods: {
    getModelDefault(){
        return {
            label : null,
            dataType:null,
            isRequired:false,
            combo:[]
        }
    },
    confirmCustom() {
      let validate = this.$refs.form.validate();
      this.confirm(true, validate);
      if (validate) this.$refs.form.resetValidation();
    },
  },
};
</script>